import { render, staticRenderFns } from "./briefcase.html?vue&type=template&id=0e2ef14a&scoped=true&external"
import script from "./briefcase.js?vue&type=script&lang=js&external"
export * from "./briefcase.js?vue&type=script&lang=js&external"
import style0 from "./briefcase.scss?vue&type=style&index=0&id=0e2ef14a&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e2ef14a",
  null
  
)

export default component.exports